import wx from "weixin-js-sdk-ts";
import sha1 from "sha1";
export interface ConfigInfo {
  debug?: boolean;
  appId: string;
  timestamp: number;//当前的时间戳
  nonceStr: string; //随机字符串
  jsApiList?: wx.ApiMethod[];
}
export interface ShareInfo {
  title: string; // 分享标题
  desc: string; // 分享描述
  link: string; // 分享链接
  imgUrl: string; // 分享图标
  // 用户确认分享后执行的回调函数
  success(): void;
  // 用户取消分享后执行的回调函数
  cancel(): void;
}

/**
 * 初始化设置 在调用config后会有两个结果，成功和失败。可以通过微信提供的两个接口来进行事件回调。
 */
export function initConfig(
  configInfo: ConfigInfo,
  jsapi_ticket: string,
  url: string,
  appConfig?: wx.IupdateAppMessageShareData,
  timelineConfig?: wx.IupdateAppMessageShareData
) {
  console.log("appConfig", appConfig)
  console.log("timelineConfig", timelineConfig)
  return new Promise((resolve) => {
    const signature = `jsapi_ticket=${jsapi_ticket}&noncestr=${configInfo.nonceStr}&timestamp=${configInfo.timestamp}&url=${url}`;
    console.log(signature, sha1(signature), jsapi_ticket, configInfo);
    // 通过config接口注入权限验证配置
    wx.config({
      debug:
        process.env.NODE_ENV === "development"
          ? true
          : false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: configInfo.appId, // 必填，企业号的唯一标识 此处填写企业号corpid
      timestamp: configInfo.timestamp, // 必填，生成签名的时间戳
      nonceStr: configInfo.nonceStr, // 必填，生成签名的随机串
      signature: sha1(signature), // 必填，签名
      jsApiList: configInfo.jsApiList || [ //必填，需要使用的JS接口列表
        "updateTimelineShareData",
        "updateAppMessageShareData",
        "onMenuShareWeibo",
      ], // 必填，需要使用的JS接口列表
      openTagList: [],
    });

    // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
    wx.ready(() => {
      if(appConfig){
        wx.updateAppMessageShareData(appConfig)
      }
      if(timelineConfig){
        wx.updateTimelineShareData(timelineConfig)
      }
      resolve(true);
    });
    wx.error(function(res){
      console.log("init error", res.errMsg);
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
  });
  });
}

// 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
export function updateAppMessageShareData(
  shareInfo: wx.IupdateAppMessageShareData
) {
  console.log("shareInfo", shareInfo);
  wx.updateAppMessageShareData(shareInfo);
}

// 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
export function updateTimelineShareData(
  shareInfo: wx.IupdateTimelineShareData
) {
  wx.updateTimelineShareData(shareInfo);
}

// 批量隐藏功能按钮接口
export function hideMenuItems(
  menuList: Array<wx.menuProtected | wx.menuShare>
) {
  wx.hideMenuItems({
    menuList: menuList, // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
  });
}

// 批量显示功能按钮接口
wx.showMenuItems({
  menuList: [] // 要显示的菜单项，所有menu项见附录3
});

// 显示所有功能按钮接口
export function showAllNonBaseMenuItem () {
  wx.showAllNonBaseMenuItem();
}


const AUTHORIZE_BASE_URL = "https://open.weixin.qq.com/connect/oauth2/authorize"

export function getUserAuthorize(appId: string, redirectUri: string, state?: string){
  window.location.href =  AUTHORIZE_BASE_URL + `?appid=${appId}`
  + `&redirect_uri=${redirectUri}`
  + `&response_type=code`
  + `&scope=snsapi_userinfo`
  + `&state=${state}`
  + `#wechat_redirect`
}
